<div class="schedule-card">
<div class="form-container">
  <div class="header">
    <h3>Schedule Inspection</h3>
    <mat-icon class="expand-icon">expand_less</mat-icon>
  </div>

  <div class="dynamic-form-layout">
    <ng-container *ngFor="let field of dynamicFields" [ngSwitch]="field.dataEntityTypeCode">

      <ng-container *ngSwitchCase="'list-data'">

        <div *ngIf="field.controlType === 'dropdown'" class="field-half-width custom-dropdown-container">
            <label class="custom-floating-label" *ngIf="field.label">
              {{ field.label }} <span *ngIf="field.isRequired" class="req">*</span>
            </label>
            <div class="common-dropdown-height">
          <wm-common-dropdown
            [data]="dropdownDataMap[field.$id]"
            [required]="true"
            (change)="onDropdownChange(field.$id, $event)">
          </wm-common-dropdown>
            </div>
        </div>

        <div *ngIf="field.controlType === 'radio'" class="field-full-width radio-mt">
          <label class="group-label">{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></label>
          <div class="radio-override-container">
            <wm-common-radio
              [data]="radioDataMap[field.$id]"
              (valueChange)="onRadioChange(field.$id, $event)">
            </wm-common-radio>
          </div>
        </div>

      </ng-container>

      <ng-container *ngSwitchCase="'date'">
        <div class="field-half-width">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="full-width hide-subscript">
            <mat-label>{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></mat-label>

            <input matInput [value]="getFormattedDateTime(field.$id, field.includeTime)" readonly placeholder="MM/DD/YYYY">
            <mat-icon matSuffix class="picker-icon" [matMenuTriggerFor]="dynamicDatetimeMenu">event</mat-icon>

            <mat-menu #dynamicDatetimeMenu="matMenu" class="custom-datetime-menu-panel" yPosition="below" xPosition="after">
              <div class="datetime-picker-wrapper" (click)="$event.stopPropagation()">

                <div class="calendar-wrapper">
                  <mat-calendar [(selected)]="selectedDateMap[field.$id]"></mat-calendar>
                </div>

                <div class="time-wrapper" *ngIf="field.includeTime">
                  <div class="time-col">
                    <div class="time-active">{{ timeStateMap[field.$id]?.hour }}</div>
                    <div class="time-list">
                      <div class="time-opt" *ngFor="let h of hours"
                            [class.selected]="h === timeStateMap[field.$id]?.hour"
                            (click)="setTime(field.$id, 'hour', h)">{{ h }}</div>
                    </div>
                  </div>
                  <div class="time-col">
                    <div class="time-active">{{ timeStateMap[field.$id]?.minute }}</div>
                    <div class="time-list">
                      <div class="time-opt" *ngFor="let m of minutes"
                            [class.selected]="m === timeStateMap[field.$id]?.minute"
                            (click)="setTime(field.$id, 'minute', m)">{{ m }}</div>
                    </div>
                  </div>
                  <div class="time-col">
                    <div class="time-active">{{ timeStateMap[field.$id]?.period }}</div>
                    <div class="time-list">
                      <div class="time-opt" *ngFor="let p of periods"
                            [class.selected]="p === timeStateMap[field.$id]?.period"
                            (click)="setTime(field.$id, 'period', p)">{{ p }}</div>
                    </div>
                  </div>
                </div>

              </div>
            </mat-menu>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'free-form-text'">
        <div [ngClass]="field.isMultiline ? 'field-full-width' : 'field-half-width'">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="full-width hide-subscript">
            <mat-label>{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></mat-label>
            <input matInput [(ngModel)]="formValues[field.$id]" *ngIf="!field.isMultiline">
            <textarea matInput [(ngModel)]="formValues[field.$id]" rows="3" *ngIf="field.isMultiline"></textarea>
          </mat-form-field>
        </div>
      </ng-container>

    </ng-container>
  </div>

  <div class="actions">
    <button mat-stroked-button class="cancel-btn" (click)="onCancel()">CANCEL</button>
    <button mat-flat-button color="primary" class="confirm-btn" [disabled]="!isFormValid" (click)="onSubmit()">CONFIRM</button>
  </div>
</div>
</div>
